import { type AbstractControl, type FormGroup, NonNullableFormBuilder, type ValidationErrors, Validators } from '@angular/forms';
import { Injectable, inject } from '@angular/core';
import { MAX_FIELD_LENGTH_DICTIONARY } from '@pecan/shared/constants/max-field-length-dictionary.constant';
import { PhoneTypeEnum } from '@pecan/api/enums';
import { phoneInfoRequiredValidator } from '../validators/phone-info-required.validator';

@Injectable({ providedIn: 'root' })
export class PhoneFormService {
    private readonly _fb: NonNullableFormBuilder = inject(NonNullableFormBuilder);

    public createFormGroup({ isPhoneRequired }: { isPhoneRequired: boolean }): FormGroup {
        const group = this._fb.group(
            {
                ext: this._fb.control('', Validators.maxLength(MAX_FIELD_LENGTH_DICTIONARY.ext)),
                isPrimary: this._fb.control(false),
                phoneInfo: this._fb.control(
                    { phone: '', locale: { isoCode: '', countryCode: '' } },
                    isPhoneRequired ? [phoneInfoRequiredValidator] : []
                ),
                type: this._fb.control(PhoneTypeEnum.Office),
            },
            { validators: this._phoneExtRequiresNumberValidator }
        );

        return group;
    }

    private readonly _phoneExtRequiresNumberValidator: (control: AbstractControl) => ValidationErrors | null = (
        control: AbstractControl
    ): ValidationErrors | null => {
        const ext = control.get('ext')?.value;
        const phone = control.get('phoneInfo')?.value?.phone;

        return ext && !phone ? { phoneRequired: true } : null;
    };
}
